import { RentalManagementTypeEnum } from 'common/enums/rental-management-type.enum';
import { RentalPaymentStatusEnum } from 'common/enums/rental-payment-status.enum';

export const formatRentalPropertyNumber = (id: number): string => `RP-${String(id).padStart(5, '0')}`;

const SETTLED_PAYMENT_STATUSES = [RentalPaymentStatusEnum.Paid, RentalPaymentStatusEnum.Refunded];

export const formatRentalFee = (paymentStatus: RentalPaymentStatusEnum, isFeeEnabled?: boolean, fee?: number): string => {
  if (paymentStatus === RentalPaymentStatusEnum.Waived) {
    return '$0.00';
  }

  const isCharged = SETTLED_PAYMENT_STATUSES.includes(paymentStatus) || isFeeEnabled === true;

  return `$${(isCharged ? fee ?? 0 : 0).toFixed(2)}`;
};

export const formatRentalAgencyChangeNumber = (id: number): string => `AG-${String(id).padStart(5, '0')}`;

export const formatRentalPropertyAgencyLabel = (managementType: RentalManagementTypeEnum, managingAgencyName: string | null): string => {
  if (managementType === RentalManagementTypeEnum.Agency) {
    return managingAgencyName ?? '—';
  }

  return 'Manage Myself';
};

export const formatRentalAgencyTransitionLabel = (
  previousManagementType: RentalManagementTypeEnum,
  previousManagingAgencyName: string | null,
  requestedManagementType: RentalManagementTypeEnum,
  requestedManagingAgencyName: string | null,
): string => {
  const previous = formatRentalPropertyAgencyLabel(previousManagementType, previousManagingAgencyName);
  const requested = formatRentalPropertyAgencyLabel(requestedManagementType, requestedManagingAgencyName);

  return `${previous} → ${requested}`;
};
